import { Routes, Route, Navigate } from "react-router-dom";
import AuthorisationPage from "src/pages/authorisation-page/authorisation-page";
import CaseLandingPage from "src/pages/case-landing/case-landing-page";
import { ThankYouPage } from "src/pages/thank-you-page/thank-you-page";
import { RequireCustomerData } from "./require-customer-data";
import { BankDetailsPage } from "src/pages/bank-details-page/bank-details-page";
import ChallengePage from "src/pages/challenge-page/challenge-page";
import { ConfirmChallengePage } from "src/pages/confirm-challenge-page/confirm-challenge-page";
import { TitleWrapper } from "src/components/layout/title-wrapper";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AuthorisationPage />} />
      <Route element={<TitleWrapper />}>
        <Route
          path="/case"
          element={
            <RequireCustomerData>
              <CaseLandingPage />
            </RequireCustomerData>
          }
        />
        <Route
          path="/bank-details"
          element={
            <RequireCustomerData>
              <BankDetailsPage />
            </RequireCustomerData>
          }
        />
        <Route
          path="/confirm-challenge"
          element={
            <RequireCustomerData>
              <ConfirmChallengePage />
            </RequireCustomerData>
          }
        />
        <Route
          path="/challenge"
          element={
            <RequireCustomerData>
              <ChallengePage />
            </RequireCustomerData>
          }
        />
      </Route>
      <Route
        path="/thank-you"
        element={
          <RequireCustomerData>
            <ThankYouPage />
          </RequireCustomerData>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
